export enum TrackingScope {
	Internal,
	ThirdParty,
	Environment,
}
